/* eslint-disable no-underscore-dangle */

const ptErrors = {
  'string.empty': 'Campo obrigatório',
  'array.includes': 'Campo obrigatório',
  'array.items.base': 'Campo obrigatório',
  'date.base': 'Campo obrigatório',
  'object.base': 'Campo obrigatório',
  'custom.beforeDate': 'Data inválida',
  'custom.afterDate': 'Data inválida',
  'custom.passedDate': 'Data inválida',
  'custom.equalsfields': 'Campos iguais',
  'string.email': 'O email deve ser um email válido',
  'custom.inThePast': 'Não pode ser uma data retroativa',
  'string.pattern.base': 'Campo com formato inválido',
  'custom.requiredValue': 'Campo obrigatório',
  'number.base': 'O valor informado deve ser um número',
  'alternatives.types': 'Campo obrigatório',
};

export const validateAndGenerateErrors = (formValues, schema, context = {}) => {
  const fieldsWithoutErrors = Object.fromEntries(
    Object.keys(formValues).map((e) => [e, false]),
  );

  const { error = false } = schema.validate(formValues, {
    messages: ptErrors,
    abortEarly: false,
    allowUnknown: true,
    context,
  });

  return {
    isValid: error === false,
    errors: {
      ...fieldsWithoutErrors,
      ...(error
        ? Object.fromEntries(
            error.details.map((a) => [a.context.label, a.message]),
          )
        : {}),
    },
  };
};
